__turbopack_context__.v({
  "container": "GpOMFG_container",
  "icon": "GpOMFG_icon",
  "variant--info": "GpOMFG_variant--info",
  "variant--success": "GpOMFG_variant--success",
  "variant--warning": "GpOMFG_variant--warning",
});
